export default __webpack_public_path__ + "static/media/img_zigzag.393584d0.png";